const COLORS = ['#7cb5ec', '#ffff00', '#90ed7d', '#f7a35c', '#8085e9', '#f15c80', '#e4d354', '#2b908f', '#f45b5b', '#91e8e1'];

export default COLORS;
